import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: 2,
        p: 4,
        textAlign: 'center',
      }}
    >
      <Typography variant="h1" sx={{ fontSize: '8rem', fontWeight: 'bold', color: 'white', lineHeight: 1 }}>
        404
      </Typography>
      <Typography variant="h5" sx={{ color: 'white' }}>
        Page not found
      </Typography>
      <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.7)' }}>
        The page you're looking for doesn't exist.
      </Typography>
      <Button
        component={Link}
        to="/"
        variant="contained"
        size="large"
        sx={{ mt: 2 }}
      >
        Go Home
      </Button>
    </Box>
  );
}

export default NotFound;
